<template>
    <div id="pages">
        <div class="map" id="container"></div>
        <div class="flexContainer flexContainers">
            <Header></Header>
            <div id="backhtml" @click="toHome">
                <i class="el-icon-arrow-left"></i>返回首页
            </div>
            <!--             <div style="height: 116px;"></div>-->
            <div class="left_column leftColumn" style="position: absolute; top: 82px; left: 2%;">
                <Charta></Charta>
            </div>
            <div class="right_column rightColumn" style="position: fixed; top: 82px; right: 3%;">
                <div class="right-center">
                    <Chartb ref="chartb"></Chartb>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Header from '@/components/Header';
import Charta from '@/components/Charta'
import Chartb from '@/components/Chartb'
import echarts from 'echarts';
import mapJson from '../../assets/shanxi.json';

export default {
    components: {
        Header,
        Charta,
        Chartb,
    },
    data() {
        return {
            map: '',
            infoWindow: '',
            keyword: '',
            keywords: '',
            showHide: 0,
            marker: '',
            timer: '',
            n: 0,
            list: []
        }
    },
    mounted() {
        this.keywords = this.$route.query.map
        this.initMap()
        this.getData()
    },
    methods: {
        getData() {
            var that = this
            that.axios.get(this.$url.baseUrl + 'index/ulist?map=' + that.keywords, {
            })
                .then(function (res) {
                    // console.log(res.data.data,"ditu")
                    if (res.data.code == 1) {
                        that.list = res.data.data
                        if (that.list && that.list.length) {
                            that.setCenter(that.list[0].longitude, that.list[0].latitude)
                        }
                        // 循环初始化所有坐标点
                        that.list.forEach(v => {
                            that.initMarker({ lng: v.longitude, lat: v.latitude, img: v.imgurl, imei: v.people }, v)
                        })
                        // 通过定时器对地图坐标进行轮播
                        that.setInter()
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        // 初始化地图控件方法
        initMap() {
            // this.map = new AMap.Map(document.getElementById("container"), {
            const loc = this.getDefaultLocation(this.keywords)
            var map = new AMap.Map("container", {
                mapStyle: 'amap://styles/darkblue',
                resizeEnable: false,
                center: [loc.lng, loc.lat],//地图中心点
                zoom: 13,//地图显示的缩放级别
                keyboardEnable: false,
                zoomEnable: true,
                dragEnable: true,
                viewMode: "3D", //使用3D视图
                animateEnable: true
            });
            this.map = map
        },
        getDefaultLocation(cityName) {
            if (!cityName) return { lat: 37.88, lng: 112.55 }
            const locations = {
                '大同市': { lat: 40.09, lng: 113.34 },
                '朔州市': { lat: 39.33, lng: 112.43 },
                '忻州市': { lat: 38.42, lng: 112.73 },
                '吕梁市': { lat: 37.52, lng: 111.14 },
                '太原市': { lat: 37.88, lng: 112.55 },
                '阳泉市': { lat: 37.86, lng: 113.58 },
                '晋中市': { lat: 37.69, lng: 112.75 },
                '长治市': { lat: 36.20, lng: 113.12 },
                '临汾市': { lat: 36.09, lng: 111.52 },
                '晋城市': { lat: 35.49, lng: 112.85 },
                '运城市': { lat: 35.03, lng: 111.01 }
            }
            return locations[cityName]
        },
        fetch() {
            this.initMap();
        },
        // 初始化坐标点的icon
        initMarker(location, item) {
            // console.log('Location', location, item)
            this.$refs.chartb.mapStateHand();
            // 生成坐标点icon
            let icon = new AMap.Icon({
                size: new AMap.Size(20, 26),
                image: location.img,
                imageSize: new AMap.Size(20, 26)
            });
            // 坐标点 生成方法
            this.marker = new AMap.Marker({
                icon: icon, // 坐标点图标
                position: [location.lng, location.lat], // 左边点的经纬度
                offset: new AMap.Pixel(0, -30) // 坐标点偏移量
            });
            // 坐标点添加点击事件 用来打开自定义窗口 也可直接添加窗口自动全部打开状态
            this.marker.on('click', (e) => {
                console.log('marker 添加点击事件：', location.imei)
                if (location.imei) {
                    this.$refs.chartb.handleSelect(location.imei);
                }
                this.initInfoWindow(location.lng, location.lat, item)
                // 点击当前标点移动至地图中心点
                this.setCenter(location.lng, location.lat)
                this.infoWindow.open(this.map, e.lnglat)

            })
            // 初始化坐标点自定义窗口
            this.initInfoWindow(location.lng, location.lat, item)
            // 打开窗口的方法 这里也可以通过 点击坐标点打开
            this.infoWindow.open(this.map, { Q: location.lat, R: location.lng, lat: location.lat, lng: location.lng })
            //

            this.mapState = true

            this.marker.setMap(this.map)
        },
        // 初始化信息窗体
        initInfoWindow(lng, lat, item) {
            // console.log('创建了信息窗体')
            this.infoWindow = new AMap.InfoWindow({
                isCustom: true,  //使用自定义窗体
                anchor: 'bottom-center',
                content: this.createInfoWindow(item),
                offset: new AMap.Pixel(0, -20),
                autoMove: true,
                closeWhenClickMap: false
            });
        },
        // 创建信息窗体
        createInfoWindow(item) {
            return ``
            //       return `
            //   <div class="dn-info-window">
            //     <div class="dn-info-name">${item.name}</div>
            //   </div>
            // `
        },
        // 轮循坐标点方法
        setInter() {
            this.timer = setInterval(() => {
                // 轮播当前标点移动至地图中心点
                this.setCenter(this.list[this.n].longitude, this.list[this.n].latitude)
                // this.initMarker({ lng: this.list[this.n].longitude, lat: this.list[this.n].latitude, img: this.list[this.n].imgurl, imei: this.list[this.n].people }, this.list[this.n])
                if (this.n == (this.list.length - 1)) {
                    this.n = 0
                } else {
                    this.n++
                }
            }, 10000)
        },
        // 当前标点移动至地图中心
        setCenter(long, lati) {
            this.map.setCenter([long, lati])
        },

        toHome() {
            this.$router.go(-1);
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    }
}
</script>

<style>
.rightColumn {
    width: 450px;
    height: 88%;
    float: left;
    display: inline-block;
    margin-left: 1%;
    background: url(../../img/rt_img.png) no-repeat;
    background-size: 100% 100%;
    background-color: rgba(0, 0, 0, .8);
}

.leftColumn #top,
.leftColumn #bottom {
    background-color: rgba(0, 0, 0, .8);
}

.flexContainers {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

#container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
}

.dn-info-window {
    position: relative;
    z-index: 99;
    background: #559EF1;
    padding: 9px 15px;
    border-radius: 6px;
    line-height: 28px;
    font-size: 14px;
    color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/city.vue